import { fleetImages } from "./fleetImages";

export const fleetData = [
  {
    id: "erj-190",
    model: "ERJ-190",
    fullModel: "EMBRAER 190",
    category: "Corto Alcance",
    fleetSize: "47 Aviones",
    maxCapacity: "900KG",
    autonomy: "4,537 km",
    dimensions: {
      long: "120 cm",
      width: "101 cm",
      high: "70 cm",
      weight: "70-80 kg",
    },
    image: fleetImages["erj-190"],
  },
  {
    id: "b737-800",
    model: "B737-800F",
    fullModel: "BOEING 737-800F",
    category: "Mediano Alcance",
    fleetSize: "36 Aviones",
    maxCapacity: "1,500 kg",
    autonomy: "5,765 km",
    dimensions: {
      long: "124 cm",
      width: "121 cm",
      high: "81 cm",
      weight: "180 kg",
    },
    image: fleetImages["b737-800"],
  },
  {
    id: "b737-max",
    model: "B737 MAX",
    fullModel: "BOEING 737 MAX",
    category: "Largo Alcance",
    fleetSize: "9 Aviones",
    maxCapacity: "20,000 kg",
    autonomy: "14,200 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "70-80 kg",
    },
    image: fleetImages["b737-max-kukulcan"],
  },
  {
    id: "b787-8",
    model: "B787-8",
    fullModel: "BOEING 787-8",
    category: "Largo Alcance",
    fleetSize: "9 Aviones",
    maxCapacity: "20,000 kg",
    autonomy: "14,200 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "70-80 kg",
    },
    image: fleetImages["b787-8"],
  },
  {
    id: "b787-9",
    model: "B787-9",
    fullModel: "BOEING 787-9",
    category: "Largo Alcance",
    fleetSize: "10 Aviones",
    maxCapacity: "23,000 kg",
    autonomy: "14,800 km",
    dimensions: {
      long: "403 cm",
      width: "214 cm",
      high: "160 cm",
      weight: "180 kg",
    },
    image: fleetImages["b787-9"],
  },
];

export const getPlaneImageViews = (plane) => {
  const planeName = plane?.fullModel || plane?.model || "avión";

  if (!plane?.image) {
    return [];
  }

  return [
    {
      src: plane.image,
      label: planeName,
    },
  ];
};
